import React from 'react';
import styled, {keyframes} from "styled-components";

import {
    CommentContainer,
    CommentCaptionContainer,
} from "#app/components/application/components/application/CommentSection/styles";
import {
    ActionsContainer,
    AvatarBox,
    Name,
    NameContainer,
    ProfileContainer,
    ProfileInfo,
    ProfileMain,
    StatusContainer,
} from "#app/components/application/components/application/styles";
import {ListItemContainer, ListItemDivider} from "#app/components/common/ListItem/styles";

const shimmer = keyframes`
    0% { opacity: 0.6; }
    50% { opacity: 0.8; }
    100% { opacity: 0.6; }
`;

const SkeletonItem = styled(ListItemContainer)`
    opacity: 0.8;
    animation: ${shimmer} 1.5s ease-in-out infinite;
    pointer-events: none;
`;

const SkeletonAvatar = styled(AvatarBox)`
    background-color: #454650;
    animation: ${shimmer} 1.5s ease-in-out infinite;
`;

const SkeletonNameLine = styled.div<{ $width?: string }>`
    height: 14px;
    background-color: #454650;
    border-radius: 4px;
    width: ${(props) => props.$width || "100%"};
    animation: ${shimmer} 1.5s ease-in-out infinite;
    margin-bottom: 2px;
`;

const SkeletonStatusText = styled.div`
    height: 12px;
    background-color: #454650;
    border-radius: 4px;
    width: 60px;
    animation: ${shimmer} 1.5s ease-in-out infinite;
    margin-bottom: 4px;
`;

const SkeletonStatusIcon = styled.div`
    width: 20px;
    height: 20px;
    background-color: #454650;
    border-radius: 4px;
    animation: ${shimmer} 1.5s ease-in-out infinite;
`;

const SkeletonComment = styled(CommentCaptionContainer)`
    background-color: #333443;
    min-height: 20px;
    animation: ${shimmer} 1.5s ease-in-out infinite;
`;

const ListSkeleton: React.FC<{ count?: number }> = ({count = 12}) => {
    return (
        <>
            {Array.from({length: count}).map((_, index) => (
                <React.Fragment key={`skeleton-${index}`}>
                    <SkeletonItem>
                        <ProfileContainer>
                            <ProfileMain>
                                <SkeletonAvatar/>
                                <ProfileInfo>
                                    <NameContainer>
                                        <Name>
                                            <SkeletonNameLine $width="80%"/>
                                            <SkeletonNameLine $width="60%"/>
                                        </Name>
                                    </NameContainer>
                                </ProfileInfo>
                            </ProfileMain>
                            <ActionsContainer>
                                <StatusContainer>
                                    <SkeletonStatusText/>
                                    <SkeletonStatusIcon/>
                                </StatusContainer>
                            </ActionsContainer>
                        </ProfileContainer>
                        <CommentContainer>
                            <SkeletonComment/>
                        </CommentContainer>
                    </SkeletonItem>
                    <ListItemDivider/>
                </React.Fragment>
            ))}
        </>
    );
};

export default ListSkeleton;
